import { Component } from '@theme/component';
import { QuantitySelectorUpdateEvent } from '@theme/events';

class QuantitySelectorComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#syncPlusButtonState();
  }

  increaseQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return;

    event.preventDefault();
    const plus = this.querySelector('.quantity-plus');
    if (plus && plus.disabled) return;

    this.refs.quantityInput.stepUp();
    this.#onQuantityChange();
  }

  decreaseQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return;

    event.preventDefault();
    this.refs.quantityInput.stepDown();
    this.#onQuantityChange(event);
  }

  selectInputValue(event) {
    const { quantityInput } = this.refs;
    if (!(event.target instanceof HTMLInputElement) || document.activeElement !== quantityInput) return;

    quantityInput.select();
  }

  setQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return;

    event.preventDefault();
    if (event.target instanceof HTMLInputElement) {
      this.refs.quantityInput.value = event.target.value;
    }
    this.#onQuantityChange(event);
  }

  #onQuantityChange() {
    const { quantityInput } = this.refs;

    this.#checkQuantityRules();
    this.#syncPlusButtonState();
    const newValue = parseInt(quantityInput.value, 10);

    quantityInput.dispatchEvent(new QuantitySelectorUpdateEvent(newValue, Number(quantityInput.dataset.cartLine)));
  }

  #checkQuantityRules = () => {
    const { quantityInput } = this.refs;
    const min = parseInt(quantityInput.min, 10);
    const max = quantityInput.max ? parseInt(quantityInput.max, 10) : NaN;
    let newValue = parseInt(quantityInput.value, 10);

    if (!Number.isNaN(min) && newValue < min) quantityInput.value = String(min);
    if (!Number.isNaN(max) && newValue > max) quantityInput.value = String(max);
  };

  #syncPlusButtonState() {
    const { quantityInput } = this.refs;
    if (!quantityInput) return;

    const plus = this.querySelector('.quantity-plus');
    if (!plus) return;

    const value = parseInt(quantityInput.value, 10);
    const max = quantityInput.max ? parseInt(quantityInput.max, 10) : NaN;
    const atMax = Number.isFinite(max) && !Number.isNaN(value) && value >= max;

    plus.disabled = atMax;
    plus.classList.toggle('quantity-plus--limit', atMax);
    plus.setAttribute('aria-disabled', atMax ? 'true' : 'false');
  }

  get quantityInput() {
    if (!this.refs.quantityInput) {
      throw new Error('Missing <input ref="quantityInput" /> inside <quantity-selector-component />');
    }

    return this.refs.quantityInput;
  }
}

if (!customElements.get('quantity-selector-component')) {
  customElements.define('quantity-selector-component', QuantitySelectorComponent);
}
